<template>
	<div class="row p-0 m-0">
		<div class="col-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 mt-1 text-center">
			<p class="p-0 m-0 fuente-titulo">Aviso de privacidad</p>
			<p class="p-0 m-0 fuente-subtitulo">
				<i class="fas fa-calendar-alt mb-3" ></i>&nbsp;Última actualización: 20 de Octubre de 2022.
			</p>
		</div>
		<!-- <div
			class="col-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 mt-4 mb-4 fondo-blanco fuente-texto"
		>
			<p>
				DIFARMER, S.A. DE C.V., en lo sucesivo DIFARMER, con domicilio ubicado en Ave. Federalismo 4767 Bodega 07, Col. Las Flores, C.P. 80104, Culiacán, Sinaloa, suscribe el presente AVISO DE PRIVACIDAD
				en cumplimiento de las disposiciones contenidas en la Ley Federal de Protecci&oacute;n de Datos Personales en Posesi&oacute;n de Particulares (LFPDPPP) y su Reglamento.
			</p>

			<p>
				Los datos personales que usted (en lo sucesivo "el Titular") ha proporcionado directamente o a trav&eacute;s de medios electr&oacute;nicos a DIFARMER (en lo sucesivo "el Responsable"), han sido recabados y ser&aacute;n
				tratados por DIFARMER bajo los principios de licitud, consentimiento, informaci&oacute;n, calidad, finalidad, lealtad, proporcionalidad y responsabilidad, de conformidad con lo dispuesto en el art&iacute;culo 6 de la
				Ley Federal de Protecci&oacute;n de Datos Personales en Posesi&oacute;n de Particulares (LFPDPPP) y su Reglamento.
			</p>

			<p>
				DIFARMER podr&aacute; recabar datos personales sensibles en funci&oacute;n del servicio o producto contratado por el Titular. De igual forma, dichos datos personales podr&aacute;n ser transferidos a tercera s personas
				ya sean f&iacute;sicas o morales, nacionales o extranjeras,con el &uacute;nico prop&oacute;sito de cumplir con los fines señalados en el presente aviso de privacidad.
			</p>

			<p>
				DIFARMER hace de su conocimiento que los datos personales proporcionados por el Titular ser&aacute;n utilizados para (i) fines de identificaci&oacute;n ;(ii) integrar su expediente como cliente;(iii) prestar los
				servicios que pudieran llegar a ser o hayan sido contratados; (iv) as&iacute; como llevar a cabo la adquisici&oacute;n de los derechos o productos relacionados con los mismos;(v) fines estad&iacute;sticos;y (vi) para
				ventualmente contactarlo por tel&eacute;fono, mensajer&iacute;a, correo postal, o correo electr&oacute;nico con el fin de compartirle noticias de inter&eacute;s de DIFARMER,sobre los servicios o productos que comercializa.
			</p>

			<p>
				Los datos personales proporcionados a DIFAMER, se encontrar&aacute;n debidamente protegidos a trav&eacute;s de medidas de seguridad tecnol&oacute;gicas, f&iacute;sicas y administrativas, previniendo el uso o divulgaci&oacute;n
				indebida de los mismos. Usted podr&aacute; ejercer sus derechos ARCO (acceso, rectificaci&oacute;n,cancelaci&oacute;n y/u oposici&oacute;n) contactando directamente al responsable en el correo electr&oacute;nico:
				atencionaclientes@difarmer. com . La solicitud de acceso, rectificaci&oacute;n, cancelaci&oacute;n u oposici&oacute;n deber&aacute; contener y acompañarse de la informaci&oacute;n y documentos a que hace referencia el art&iacute;culo 29 de
				la Ley Federal de Protecci&oacute;n de Datos Personales en Posesi&oacute;n de Particulares (LFPDPPP). El presente aviso de privacidad podr&aacute; ser modificado o actualizado unilateralmente por DIFARMER,
				inform&aacute;ndole al Titular de dichos cambios a través de su p&aacute;gina web.
			</p>

			<p>
				No seremos responsables si usted no recibe la notificaci&oacute;n de cambio en el aviso de privacidad,si existiere alg&uacute;n problema con su cuenta de correo electrónico o de transmisi&oacute;n de datos por internet.
				Por su seguridad, revise en todo momento que as&iacute; lo desee el contenido de este aviso de privacidad en nuestra página www.difarmer.com
			</p>
		</div> -->
		<iframe src="https://www.difarmer.com/AvisosPrivacidad/difarmer.pdf" class="m-3" style="width:100%;height:75vh"></iframe>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.ocultarChat()
		}
	}
</script>

<style scoped>
	.fuente-titulo {
		font-weight: 600;
		font-style: italic;
		color: var(--color-azul);
	}
	.fuente-subtitulo {
		color: var(--color-azul);
	}
	.fuente-texto {
		font-family: "Open Sans";
		color: var(--color-gris-dark);
	}
	.fondo-blanco {
		background-color: var(--color-blanco);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-titulo {
			font-size: 20px !important;
		}
		.fuente-subtitulo {
			font-size: 12px !important;
		}
		.fuente-texto {
			font-size: 14px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-titulo {
			font-size: 20px !important;
		}
		.fuente-subtitulo {
			font-size: 12px !important;
		}
		.fuente-texto {
			font-size: 14px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-titulo {
			font-size: 16px !important;
		}
		.fuente-subtitulo {
			font-size: 12px !important;
		}
		.fuente-texto {
			font-size: 14px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-titulo {
			font-size: 16px !important;
		}
		.fuente-subtitulo {
			font-size: 14px !important;
		}
		.fuente-texto {
			font-size: 14px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 14px !important;
		}
		.fuente-texto {
			font-size: 16px !important;
		}
	}
</style>
